import React, { ReactElement, useState } from 'react';
import { Button, Modal, ToggleButton } from 'react-bootstrap';
import './LiveHeader.scss';
import {
  useEndDeliveryLiveMutation,
  useEndViewLiveMutation,
  usePutMirrorOffMutation,
  usePutMirrorOnMutation,
  usePutMuteOffMutation,
  usePutMuteOnMutation,
} from '../../../../services/api/apiProvider';

import { LiveProps } from '../../LiveContainer';
import PuffLoader from 'react-spinners/PuffLoader';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../../store/store';

export const LiveHeader = (props: LiveProps): ReactElement => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isEndLive, setIsEndLive] = useState<boolean>(false);
  const [endView] = useEndViewLiveMutation();
  const [stopDelivery] = useEndDeliveryLiveMutation();
  const [turnOnMirror] = usePutMirrorOnMutation();
  const [turnOffMirror] = usePutMirrorOffMutation();
  const [turnOnMute] = usePutMuteOnMutation();
  const [turnOffMute] = usePutMuteOffMutation();
  const liveMatchSate = useSelector((state: AppState) => state.liveMatch);

  const btnEndLiveOnClick = async () => {
    if (
      props.liveState.role === 'audience' &&
      props.liveState.liveData !== undefined
    ) {
      await endView(props.liveState.liveData.id).unwrap();
      window.location.href = `${window.location.origin}/${process.env.REACT_APP_BASE_URL}`;
    } else setIsEndLive(true);
  };

  const btnMuteAudioOnClick = () => {
    if (!props.liveState.liveData) {
      return;
    }

    if (
      props.liveState.role === 'host' &&
      props.liveState.rtcEngine?.instance?.localTracks !== undefined &&
      props.liveState.rtcEngine?.instance?.localTracks?.length > 1
    ) {
      props.liveState.rtcEngine?.instance?.localTracks[1].setMuted(
        !props.liveState.isAudioMuted,
      );
    }

    if (props.liveState.isAudioMuted) {
      turnOffMute(props.liveState.liveData.id);
    } else {
      turnOnMute(props.liveState.liveData.id);
    }
    // mute audio
    props.toggleAudio();
  };

  const btnMirrorModeOnClick = () => {
    if (!props.liveState.liveData) {
      return;
    }

    if (props.liveState.isMirrorEnable) {
      turnOffMirror(props.liveState.liveData?.id);
    } else {
      turnOnMirror(props.liveState.liveData?.id);
    }

    props.toggleMirrorMode();
  };

  const btnSettingsOnClick = () => {
    if (!props.liveState.liveData) {
      return;
    }

    props.toggleSettingsModal(true);
  };

  const handleEndLive = async () => {
    // end delivery live
    if (
      props.liveState.role === 'host' &&
      props.liveState.liveData !== undefined
    ) {
      setIsEndLive(false);
      // end live and show result
      await stopDelivery(props.liveState.liveData.id).unwrap();
      props.endLive();
    }
  };
  const handleCancelEndLive = () => {
    setIsEndLive(false);
  };

  return (
    <div
      className="live-header"
      style={{ paddingLeft: '0px', paddingRight: '0px' }}
    >
      {props.liveState.isInLive && props.liveState.role === 'host' && (
        <>
          <ToggleButton
            className="live-header__audio-btn"
            type="checkbox"
            variant={props.liveState.isAudioMuted ? 'danger' : 'primary'}
            value="1"
            disabled={props.liveState.isEnded}
            onClick={btnMuteAudioOnClick}
          >
            {t('Audio')}: {props.liveState.isAudioMuted ? 'Off' : 'On'}
          </ToggleButton>

          {props.liveState.isLive ? (
            <ToggleButton
              className="live-header__mirror-btn"
              type="checkbox"
              variant={props.liveState.isMirrorEnable ? 'primary' : 'danger'}
              value="1"
              disabled={props.liveState.isEnded}
              onClick={btnMirrorModeOnClick}
            >
              {t('Mirror')}: {props.liveState.isMirrorEnable ? 'On' : 'Off'}
            </ToggleButton>
          ) : (
            <></>
          )}

          <Button
            className="live-header__settings-btn"
            disabled={props.liveState.isEnded}
            onClick={btnSettingsOnClick}
          >
            {t('Settings')}
          </Button>
        </>
      )}

      {props.liveState.isInLive || props.liveState.isEnded ? (
        <ToggleButton
          className="live-header__end-live-btn"
          variant="danger"
          value="1"
          disabled={props.liveState.isEnded}
          onClick={btnEndLiveOnClick}
        >
          {props.liveState.role === 'host' ? (
            <>{liveMatchSate.isLiveMatch ? 'EndLiveMatch' : t('EndLive')}</>
          ) : (
            t('Leave')
          )}
        </ToggleButton>
      ) : (
        <PuffLoader
          size={'42px'}
          color={'#d9534f'}
          cssOverride={{ marginLeft: 'auto' }}
        ></PuffLoader>
      )}
      {/* Modal confirm end live */}
      <Modal
        backdrop="static"
        keyboard={false}
        centered
        scrollable={true}
        show={isEndLive}
      >
        <Modal.Header>ライブ配信を終了しますか？</Modal.Header>
        <Modal.Footer style={{ justifyContent: 'end' }}>
          <Button variant="primary" onClick={handleEndLive}>
            OK
          </Button>
          <Button variant="secondary" onClick={handleCancelEndLive}>
            キャンセル
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
